import { showToast } from '@tencent/wphk-components-toast';
import { showDialog } from '@tencent/wphk-components-dialog';
import { i18n, initLang } from './i18n';


/** 复制功能
  * [example]
  * copy({text:'复制内容'});
 */
export function copy(option, lang) {
  initLang(lang);
  let { success, fail } = option;
  const { text } = option;

  if (!text) {
    throw new Error('请传入需要复制的文本内容');
  }

  success = success || successCopy;
  fail = fail || failCopy;

  const successed = copyText(text);

  if (successed) {
    success();
  } else {
    fail();
  }
}

function successCopy() {
  showToast({
    title: i18n('复制成功'),
    duration: 1000,
  });
}

function failCopy() {
  showDialog({
    content: i18n('复制失败，请长按复制'),
    btns: [{
      text: i18n('好的'),
    }],
  });
}

function copyText(text) {
  const domId = 'copyTextElement';
  createCopyElement(domId, text); // 创建复制textarea
  let succeeded = void 0;
  try {
    const el = document.getElementById(domId);
    // @ts-ignore
    el.select();
    // @ts-ignore
    succeeded = document.execCommand('Copy');
  } catch (err) {
    // @ts-ignore
    succeeded = false;
  }
  removeCopyElement(domId);
  return succeeded;
}

function createCopyElement(domId, text) {
  let el = document.getElementById(domId);
  if (el) {
    // @ts-ignore
    el.value = text;
  } else {
    el = createFakeElement(domId);
    // @ts-ignore
    el.value = text;
    document.body.appendChild(el);
  }
}

function createFakeElement(domId) {
  const el = document.createElement('textarea');
  el.setAttribute('readonly', '');
  el.id = domId;
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  el.style.top = '-9999px';
  return el;
}

function removeCopyElement(domId) {
  const el = document.getElementById(domId);
  if (el) {
    // @ts-ignore
    el.value = '';
  }
}
